import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';
import useEvidenceSections from 'components/forms/evidence-field/use-evidence-sections';

/** Filters the section reference using the same catalog as the field form. */
export default function EvidenceFieldSectionSelectFilter({
  api,
  onChange,
}: {
  api: GridApi;
  onChange?: FilterChangeCallback;
}) {
  const { sections } = useEvidenceSections();
  const [value, setValue] = useFilterValue({ api, filterKey: 'sectionId', onChange, type: 'equals' });
  return (
    <Select
      clearable
      searchable
      size="sm"
      placeholder="Všetky sekcie"
      value={value}
      onChange={setValue}
      data={sections.map((section) => ({
        value: String(section.sectionId),
        label: `${section.name} (${section.module === 'devices' ? 'Zariadenia' : 'Osoby'})`,
      }))}
    />
  );
}
